import type { CartLine, Product } from "../types/domain";

export const products: Product[] = [
  {
    id: "SKU-CT-1842",
    slug: "bo-dieu-khien-xe-dien-48v-60v",
    name: "Bộ điều khiển xe điện 48V-60V chống nước",
    category: "Xe điện",
    brand: "STUT Select",
    price: 485000,
    originalPrice: 560000,
    stock: 36,
    rating: 4.8,
    sold: 428,
    fitment: ["VinFast Klara", "Yadea", "Xe đạp điện phổ thông"],
    specs: {
      "Điện áp": "48V - 60V",
      "Công suất": "800W",
      "Bảo hành": "6 tháng"
    },
    badges: ["Bán chạy", "Có sẵn"]
  },
  {
    id: "SKU-CT-2031",
    slug: "sac-xe-dien-lithium-60v-20ah",
    name: "Sạc lithium xe điện 60V 20Ah tự ngắt",
    category: "Xe điện",
    brand: "STUT Select",
    price: 390000,
    stock: 18,
    rating: 4.7,
    sold: 216,
    fitment: ["Xe máy điện 60V", "Ắc quy lithium"],
    specs: {
      "Điện áp": "60V",
      "Dòng sạc": "3A",
      "Chế độ": "Tự ngắt"
    },
    badges: ["Bảo hành"]
  },
  {
    id: "SKU-CT-1188",
    slug: "bo-thang-dia-truoc-sh-mode",
    name: "Bố thắng đĩa trước SH Mode / Vision chính hãng",
    category: "Xe máy",
    brand: "Nissin",
    price: 165000,
    originalPrice: 190000,
    stock: 64,
    rating: 4.9,
    sold: 620,
    fitment: ["Honda Vision", "SH Mode", "Lead"],
    specs: {
      "Chất liệu": "Hợp kim ma sát",
      "Vị trí": "Trước",
      "Xuất xứ": "Thái Lan"
    },
    badges: ["Chính hãng"]
  },
  {
    id: "SKU-CT-2510",
    slug: "cam-bien-ap-suat-lop-tpms",
    name: "Cảm biến áp suất lốp TPMS van trong",
    category: "Ô tô điện",
    brand: "AutoTech",
    price: 920000,
    stock: 9,
    rating: 4.6,
    sold: 98,
    fitment: ["VF e34", "VF 5", "Ô tô điện phổ thông"],
    specs: {
      "Kiểu van": "Van trong",
      "Tần số": "433MHz",
      "Bộ": "4 cảm biến"
    },
    badges: ["Tồn thấp"]
  },
  {
    id: "SKU-CT-0773",
    slug: "nhot-xe-may-10w40-synthetic",
    name: "Nhớt tổng hợp 10W40 cho xe tay ga",
    category: "Dầu nhớt",
    brand: "Motul",
    price: 145000,
    stock: 120,
    rating: 4.8,
    sold: 810,
    fitment: ["Xe tay ga", "Xe số 4T"],
    specs: {
      "Dung tích": "0.8L",
      "Tiêu chuẩn": "API SN",
      "Gốc dầu": "Synthetic"
    },
    badges: ["Mua lại cao"]
  },
  {
    id: "SKU-CT-3319",
    slug: "day-curoa-xe-ga-vario-click",
    name: "Dây curoa xe ga Vario / Click 125",
    category: "Xe máy",
    brand: "Bando",
    price: 245000,
    stock: 42,
    rating: 4.7,
    sold: 309,
    fitment: ["Honda Vario 125", "Honda Click 125"],
    specs: {
      "Kích thước": "23100-K59",
      "Chất liệu": "Cao su bố sợi",
      "Bảo hành": "3 tháng"
    },
    badges: ["Chuẩn xe"]
  }
];

export const cartSeed: CartLine[] = [
  { product: products[0], quantity: 1 },
  { product: products[2], quantity: 2 },
  { product: products[4], quantity: 1 }
];

export const formatVnd = (value: number) =>
  new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0
  }).format(value);
